import { lms_v2_api } from "../../../services/cs-lab-config"

function getInlineAiPromptResponse(payload) {
    return lms_v2_api.post("/ideProjects/generateAiCode/",payload);
}

export { getInlineAiPromptResponse }